export const SOURCE_KEY = 'termly-master-consents-origin-sync'
